import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Layout",
    component: () => import("@/components/common/Layout/"),
    children: [
      {
        path: "/",
        name: "index",
        redirect: "/index",
        component: () => import("@/views/index/")
      },
      {
        path: "/index",
        name: "index",
        component: () => import("@/views/index/")
      },
      {
        path: "/success",
        name: "success",
        component: () => import("@/views/success/")
      },
      {
        path: "/ValidationFailed",
        name: "ValidationFailed",
        component: () => import("@/views/ValidationFailed/")
      }
    ]
  }
];

const router = new VueRouter({
  // mode: "history",
  routes
});

// 抛出错误
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js